enum DeviceRelationships {
  WORK_COLLEAGUE = 'Work Colleague',
  FAMILY = 'Family',
  VISITOR = 'Visitor',
  OTHER = 'Other',
}

export default DeviceRelationships
